import {
    CButton,
    CListGroup,
    CListGroupItem,
    CModal,
    CModalBody,
    CModalHeader,
    CModalTitle,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow
  } from '@coreui/react';
  import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';
  import styles from './Table.module.css';
import TableFooter from './TableFooter';
import { useState } from 'react';
  
  
  const CouponsTable = ({ columns, data, pagination }) => {

    const navigate = useNavigate();

    const {setCouponsPageUrl, getCouponBuyers} = useContext(AppContext);

    return (
        <>
          <CTable responsive hover>
            <CTableHead>
              <CTableRow>
                {columns.map((col, index) => (
                  <CTableHeaderCell key={index} scope="col">
                    {col.label}
                  </CTableHeaderCell>
                ))}
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {data?.map((el, index) => (
                <CTableRow key={index}>
                  <CTableDataCell>{el.id}</CTableDataCell>
                  <CTableDataCell>{el.code}</CTableDataCell>
                  <CTableDataCell>{el.couponeable_type == "company_subscription" ? "Suscripción" : "Chapita"}</CTableDataCell>
                  <CTableDataCell>{el.description}</CTableDataCell>
                  <CTableDataCell>{el.discount_type == 'PRICE' ? 'Por precio' : 'Meses gratuitos' }</CTableDataCell>
                  <CTableDataCell>{el.discount_type == 'PRICE' ? `${Math.round(el.discount * 100)}%`: el.discount }</CTableDataCell>
                  <CTableDataCell>{el.uses || "-"}</CTableDataCell>
                  <CTableDataCell>{el.times_claimed || "-"}</CTableDataCell>
                  <CTableDataCell>{el.expiration_date || "-"}</CTableDataCell>
                  <CTableDataCell>
                    <div className='d-flex'>
                    <CButton
                      className={styles.downloadQR}
                      onClick={() => {
                        navigate(`/dashboard/coupons/${el?.id}`);
                      }}
                    >
                      Ver/Editar
                    </CButton>
                    </div>
                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
          <TableFooter range={pagination?.links} setPageUrl={setCouponsPageUrl} />
      </>
    );
  };
  
  export default CouponsTable;
  